import { module } from 'modujs';
import { html } from '../utils/environment'


export default class extends module {
    constructor(m) {
        super(m);
        this.events = {
            click: 'toggleMenu'
        }
    }

    init(){

    }

    toggleMenu() {
        if(html.classList.contains('has-menu-tools-open')) {
            this.close()
        } else {
            this.open()
        }
    }

    open() {

        this.call('open', 'MenuTools')
    }

    close() {

        this.call('close', 'MenuTools')
    }
}
